
import './Acordon.css'
import React, { useState } from 'react';

const Acordon = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-container">
      <div className="accordion-heading" onClick={toggleAccordion}>
        <h2>About Us</h2>
        <div className={`accordion-icon ${isOpen ? 'open' : ''}`}>▼</div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <p>
          <section>
        <div className="container ">
          
          <div className="row">
    <div className="col-xl about-col-1">
     <h3>The ORIC-SBBWU envisions to:</h3>
     <p>Promote quality research through academia-industry linkage for strong socio- economic impact, with focus on research excellence, revenue generation and financial stability.</p>

 </div>
 </div>
          <div className="row">
    <div className="col-xl about-col-1">
      
     <p>ORIC-SBBWU serves as a platform for staff, faculty & research—oriented students to step forward and contribute to national sustainable progress by;</p>
     <ul>
      <li> Promoting an effective, innovative and entrepreneurial environment for technology-
transfer and commercialization through purpose-led research centers, and dedicated Business Incubation Center to empower women.</li>
      <li>Strengthening academia-industry linkages through collaborative ventures with the aim to improve SBBWU curricula for meeting corporate standards to advance economic stability.</li>
      <li>Developing durable and long–term pledges with policy makers and research funding agencies to enhance the culture of research, ensure development and expand innovation & commercialization horizons.</li>
      
     </ul>
 </div>
 </div>
          
  <div className="row">
    <div className="col-xl about-col-1">
     <h4>Establishment</h4>
     <p>The Syndicate in its 10th meeting, held on Monday, 9th July, 2012 has approved the establishment of Office of Research, Innovation & Commercialization of Shaheed Benazir Bhutto Women University. The responsibility of the office of ORIC may be carried out by the existing staff of the University.
   </p> 

 </div>
 </div>
 <div className="row">
    <div className="col-xl about-col-2">
      <h4>Goals</h4>
      <p>
        <ul>The ORIC seeks to enhance the environment for all research and scholarship by:
          <li>Supporting the university’s strategic research directions and policies.</li>
          <li>Increasing and diversifying external research funding.</li>
          <li>Improving recruitment and retention of top faculty.</li>
          <li>Improving integration of research and education at all levels of the university.</li>
          <li>Improving translation of research into the public benefit.</li>
          <li>Strengthening university-industry relationships.</li>
          <li>Promoting entrepreneurship, technology-transfer and commercialization activities that energize and support the local and national economy.</li>
          <li>Promoting and enhancing cross-cutting and multi-disciplinary research initiatives.</li>

        </ul>
        </p>
    </div>
    </div>
    <div className="row">
    <div className="col-xl about-col-3">
      <h4>Purpose</h4>
      <p>The purpose of the Office of Research, Innovation and Commercialization (ORIC) is to develop, expand, enhance and manage the university’s research programs and to link research activities directly to the educational, social and economic priorities of the university and its broader community. The ORIC is also responsible for assuring that the quality of research reflects the highest international standards and advances the stature of the university among the world’s best research institutions.

In pursuit of this mission the ORIC has the responsibility of guaranteeing that all research programs and policies reflect the core values of academic freedom, professional integrity and ethical conduct and full compliance with all policies, legal requirements and operational standards of the university.</p>
    </div>
    </div>
    <div className="row">
    <div className="col-xl about-col-4">
    <h4 className=".about .content h3">SOPs for Office of Research, Innovation and Commercialization (ORICs)</h4>
      <ul>
        <li>Once ORICs are established all the research proposals to HEC/other agencies etc. must be processed through ORICs.</li>
        <li>Submission of Research proposals relevant to Pakistan Socio-Economic needs.</li>
        <li>Updation of data regarding funding/donor agencies.</li>
        <li>Establishment of links with donors.</li>
        <li>Establishment of links with Industries
</li>
        <li>Arrange/conduct seminars, conferences and training programs for faculty awareness and faculty industry interaction.</li>
        <li>Identify regional expertise and requirements.</li>
        <li>Arrange International trainings and workshops.</li>
        <li>Arrange trainings and workshops at national level.</li>
        <li>Arrange International Seminars/Symposium.</li>
        <li>Arrange Seminars/Symposium at national leve</li>
        <li>Develop business plans</li>
        <li>Maintain a webpage for ORIC on the main website of the respective university and regularly update the same to make all the ORIC related activities, ranging from research proposals to information regarding donor agencies and industrial linkages established, reflected on the website.</li>
      </ul>
    </div>
    </div>
  
</div>
</section>
          </p>
        </div>
      )}
    </div>
  );
};


export default Acordon
